import React from "react";
import { Link } from "react-router-dom";
import { Copy, Video, Instagram } from "lucide-react";
import { toast } from "sonner";
import { AnimatedReel } from "../reels/AnimatedReel";
import { IG_REELS, reelDuration } from "../../lib/igReels";

function ReelTile({ reel }) {
  const copy = () => navigator.clipboard.writeText(reel.caption).then(() => toast.success("Caption copied"));
  return (
    <div className="border hairline bg-white flex flex-col" data-testid={`ig-reel-${reel.slug}`}>
      <AnimatedReel reel={reel} className="w-full" testId={`ig-reel-preview-${reel.slug}`} />
      <div className="p-3 flex flex-col gap-2 flex-1">
        <div>
          <div className="text-sm font-bold leading-tight">{reel.title}</div>
          <div className="text-[11px] text-[#666] mt-0.5">{reel.angle}</div>
          <div className="mono text-[9px] text-[#888] uppercase tracking-wider mt-1">{Math.round(reelDuration(reel.scenes()) / 1000)}s · {reel.scenes().length} scenes</div>
        </div>
        <div className="mt-auto grid grid-cols-2 gap-1.5">
          <button onClick={copy} className="btn-secondary !px-2 !py-1.5 text-[10px] inline-flex items-center justify-center gap-1" data-testid={`ig-reel-copy-${reel.slug}`}>
            <Copy className="w-3 h-3" /> Caption
          </button>
          <Link to={`/admin/instagram-reels/${reel.slug}`} className="btn-primary !px-2 !py-1.5 text-[10px] inline-flex items-center justify-center gap-1" data-testid={`ig-reel-record-${reel.slug}`}>
            <Video className="w-3 h-3" /> Record
          </Link>
        </div>
      </div>
    </div>
  );
}

export default function InstagramReelsCard() {
  return (
    <section className="border hairline rounded-2xl p-5 sm:p-6 mb-4 bg-white" data-testid="admin-instagram-reels">
      <div className="eyebrow text-[#ff4500] flex items-center gap-1.5 mb-1">
        <Instagram className="w-3.5 h-3.5" /> Instagram reels
      </div>
      <h2 className="font-display text-xl sm:text-2xl tracking-tight">Sign-up reels</h2>
      <p className="text-xs text-[#666] mt-1 mb-4 max-w-xl">
        Five animated 9:16 reels built to drive sign-ups. Tap <strong>Record</strong> for a full-screen version with a 3-second countdown, screen-record it on your phone, then post with the copied caption.
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {IG_REELS.map((r) => <ReelTile key={r.slug} reel={r} />)}
      </div>
    </section>
  );
}
